// removed by extract-text-webpack-plugin
module.exports = {"claimsList":"kp3VsUhzd3AHWLe3mRjtd"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/claims/EasinsureClaimsList.scss
// module id = 1158
// module chunks = 0